import { useCallback, useEffect, useState } from 'react';
import { ArchivalAidMetadata } from 'types';

import fetch from 'utils/fetch';

/**
 * Hook that gets rootArchivalAid, whenenever opened entity is not ArchivalUnit
 *
 *
 * @param isArchivalAUnit
 * @param level
 * @param nodeId
 * @returns
 */
export const useRootArchivalAid = (
  enabledFetch: boolean,
  level: number,
  nodeId?: string,
  archivalAidLevel: number = 0
) => {
  const [rootArchivalAid, setRootArchivalAid] = useState<ArchivalAidMetadata>();

  const requestUrl =
    level === archivalAidLevel
      ? `/api/archival-aid-metadata/${nodeId}`
      : `/api/archival-aid-metadata/ead/${nodeId}`;

  const fetchRootArchivalAid = useCallback(async () => {
    if (!nodeId || level < archivalAidLevel) {
      return;
    }
    try {
      const response = await fetch(requestUrl);

      const json = await response.json();

      if (json) {
        setRootArchivalAid(json);
      }
    } catch (e) {
      return;
    }
  }, [archivalAidLevel, level, nodeId, requestUrl]);

  useEffect(() => {
    if (enabledFetch) {
      fetchRootArchivalAid();
    } else {
      setRootArchivalAid(undefined);
    }
  }, [enabledFetch, fetchRootArchivalAid]);

  return { rootArchivalAid, refreshRootArchivalAid: fetchRootArchivalAid };
};
